export default function (value) {
    if (!value || value == 0) return 0.001.toFixed(2);
    value = parseFloat(value);
    return (Math.round(value * 100) / 100).toFixed(2);
}


// WEBPACK FOOTER //
// ./src/util/num-tofix.js